const routes = {
  home: '/',
  login: '/authentication/login',
  notAuthorized: '/not-authorized',
  auth: {
    logIn: '/authentication/login',
    passwordReset: '/authentication/password-reset',
    passwordRecovery: '/authentication/password-recovery',
    verifyCode: '/authentication/verify-code',
  },
  migration: {
    list: '/migration',
    viewPart: '/migration/part/:part_id/:tenant_id',
    viewVehicle: '/migration/vehicle/:vehicle_id/:tenant_id',
  },
  partTypes: {
    list: '/part-types',
    new: '/part-types/new',
    view: '/part-types/view/:partTypeId',
    edit: '/part-types/edit/:partTypeId',
    bulkEdit: '/part-types/bulk-edit',
    addAttribute: '/part-types/add-attribute',
    editAttribute: '/part-types/edit-attribute',
  },
  vehicleData: {
    list: '/vehicle-data',
  },
  categoryManagement: {
    list: '/category-management',
  },
  partsCatalog: {
    list: '/parts-catalog',
    add: '/parts-catalog/add',
    edit: '/parts-catalog/edit',
  },
  partsDecoder: {
    list: '/parts-decoder',
    view: '/parts-decoder/:id/:tenant_id',
  },
  officeHours: {
    list: '/office-hours',
  },
  systemNotices: {
    list: '/system-notices',
  },
  releases: {
    list: '/releases',
    create: '/releases/new',
    edit: '/releases/:releaseId/edit',
  },
  htmls: {
    list: '/htmls',
  },
  labels: {
    list: '/labels',
  },
  learnContent: {
    list: '/learn-content',
    create: '/learn-content/new',
    edit: '/learn-content/:lessonId/edit',
  },
  feedbackManagement: {
    list: '/feedback-management',
  },
  users: {
    list: '/users',
    view: '/users/:userId',
    add: '/users/new',
    edit: '/users/:userId/edit',
  },
  recordDiagnostics: {
    list: '/record-diagnostics',
  },
  saturnMigration: { list: '/saturn-migration', view: '/saturn-migration/:id' },
  stores: {
    list: '/stores',
    new: '/stores/new',
    edit: '/stores/:storeId',
    build: '/stores/:storeId/builds/:buildId',
  },
  DPCManagement: { list: '/dpcmanagement', view: '/dpcmanagement/:id' },
  partTypeStudio: {
    root: '/part-type-studio',
    all: '/part-type-studio/*',
    bases: '/part-type-studio/bases',
    base: '/part-type-studio/bases/:id',
    match: '/part-type-studio/match',
    duplicates: '/part-type-studio/duplicates',
    descriptions: '/part-type-studio/descriptions',
    changes: '/part-type-studio/changes',
    runs: '/part-type-studio/runs',
    mintInbox: '/part-type-studio/mint-inbox',
    facets: '/part-type-studio/facets',
    nameClashes: '/part-type-studio/name-clashes',
    ebayReview: '/part-type-studio/ebay-review',
    analytics: '/part-type-studio/analytics',
  },
  demos: {
    index: '/demos',
    partPricing: '/demos/part-pricing',
    auctionValuation: '/demos/auction-valuation',
    partMatching: '/demos/part-matching',
  },
};

export default routes;
